import { useState } from 'react'
import styled from 'styled-components'

import { Button, PlusIcon, Typography } from '@blade/ui-kit'
import { QuickBuyInput } from '@root/features/trade/quick-buy/ui'
import { AddWalletTrackerDialog } from '@root/features/wallet-tracker/ui/add-wallet-tracker-dialog'
import { PortWalletsDrawer } from '@root/features/wallet-tracker/ui/port-wallets-drawer'
import { useTranslation } from '@root/shared/localization'
import { layoutHeightCss } from '@root/shared/ui-kit/utils/page-layout'

import { WalletFollowingUpdatesSection } from './wallet-following-updates-section'
import { WalletTrackerTables } from './wallet-tracker-tables'

import type { ClassNameProps } from '@root/shared/react'

type WalletTrackerPageProps = {} & ClassNameProps

export const WalletTrackerPage: React.FC<WalletTrackerPageProps> = ({
  className,
}) => {
  const { t } = useTranslation()
  const [addWalletTrackerDialogOpen, setAddWalletTrackerDialogOpen] =
    useState(false)
  const [portWalletsDrawerOpen, setPortWalletsDrawerOpen] = useState(false)

  return (
    <Root className={className}>
      <Header>
        <PageTitle>{t('wallet-tracker.page.title')}</PageTitle>
        <HeaderEnd>
          <QuickBuyInput section="walletsTracker" />
          <Button
            size="h36"
            iconLeft={<PlusIcon />}
            variant="soft"
            radius="rounded"
            onClick={() => setAddWalletTrackerDialogOpen(true)}
          >
            {t('wallet-tracker.add-wallet.title')}
          </Button>
          <Button
            size="h36"
            iconLeft={<PlusIcon />}
            variant="soft"
            radius="rounded"
            onClick={() => setPortWalletsDrawerOpen(true)}
          >
            {t('wallet-tracker.port.title')}
          </Button>
        </HeaderEnd>
      </Header>
      <Content>
        <WalletFollowingUpdatesSection />
        <WalletTrackerTables />
      </Content>

      <AddWalletTrackerDialog
        open={addWalletTrackerDialogOpen}
        onOpenChange={setAddWalletTrackerDialogOpen}
      />
      <PortWalletsDrawer
        open={portWalletsDrawerOpen}
        onOpenChange={setPortWalletsDrawerOpen}
      />
    </Root>
  )
}

const Root = styled.div`
  ${layoutHeightCss}

  position: relative;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Header = styled.div`
  height: 50px;
  background: var(--background-2);
  display: grid;
  padding-inline: 10px;
  align-items: center;

  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`

const HeaderEnd = styled.div`
  display: grid;
  gap: 6px;
  align-items: center;
  grid-auto-flow: column;
`

const PageTitle = styled(Typography)`
  color: var(--text-12);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

const Content = styled.div`
  min-height: 0;
  overflow: hidden;

  display: grid;
  padding-inline: 10px;
  padding-block: 10px;
  gap: 10px;
  grid-template-columns: 310px minmax(0, 1fr);
`
